var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-loading-bar",class:{ 'is-small': _vm.isSmall }},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-loading-bar__base-bar"},[_c('div',{staticClass:"base-loading-bar__progress"})])
}]

export { render, staticRenderFns }